'use client';

import { FC, useState } from 'react';
import { useFormStatus } from 'react-dom';

import { getOr } from '@/utils/getOr';

import { InputFormProps } from '../Input/Input.type';
import { InputEmail } from './InputEmail';

type Props = InputFormProps<typeof InputEmail>;

export const InputEmailForm: FC<Props> = ({ id, name, disabled, formState, defaultValue, ...props }) => {
  const [value, setValue] = useState(defaultValue ?? '');
  const inputId = id ?? name;
  const error = getOr(formState, `errors.${name}[0]`, null);
  const { pending } = useFormStatus();

  return (
    <InputEmail
      {...props}
      pending={pending}
      id={inputId}
      name={name}
      value={value}
      defaultValue={defaultValue}
      onChange={setValue}
      error={error}
      disabled={disabled || pending}
    />
  );
};
